module.exports = __webpack_public_path__ + "static/gm-26-8614615e5f413d47c1983bf81fa215f4.jpg";